import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { useHttpContext } from '@/common/hooks/HttpContext';
import { toasts } from '@/common/toasts';
import { DashboardMeta } from '@/common/types';
import { OrganizationsTable } from '@/components/Organization/OrganizationsTable/OrganizationsTable';
import { Button } from '@/components/common/button/button';
import { resultIsError } from '@/services/HttpService';

interface ReportingThirdPartyTabProps {
    organizationId: number;
    records: DashboardMeta[];
    onDelete: () => void;
    onCreate: () => void;
}

export const ReportingThirdPartyTab = ({
    organizationId,
    records,
    onDelete,
    onCreate,
}: ReportingThirdPartyTabProps) => {
    const { httpService } = useHttpContext();
    const { errorToast, successToast } = toasts;
    const [newName, setNewName] = useState('');

    const handleCreate = async () => {
        if (!newName.trim()) return;
        const res = await httpService.createDashboardMeta(organizationId, 'thirdparty', newName.trim());
        if (resultIsError(res)) {
            errorToast(res.message);
        } else {
            successToast('Created successfully.');
            setNewName('');
            onCreate();
        }
    };

    const handleDelete = async (id: number) => {
        const res = await httpService.deleteDashboardMeta(organizationId, 'thirdparty', id);
        if (resultIsError(res)) {
            errorToast(res.message);
        } else {
            successToast('Deleted successfully.');
            onDelete();
        }
    };

    const columnStructure = [
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: '',
            id: 'actions',
            accessor: 'id',
            Cell: ({ value }) => (
                <Button onClick={() => handleDelete(value)} size="small" variant="secondary">
                    Delete
                </Button>
            ),
        },
    ];

    return (
        <>
            <OrganizationsTable columnStructure={columnStructure} data={records} />
            <div
                style={{
                    backgroundColor: 'white',
                    padding: '16px 24px 16px 40px',
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    alignItems: 'center',
                }}
            >
                <TextField
                    size="small"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                    placeholder="Enter name"
                    onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
                    variant="outlined"
                    inputProps={{ maxLength: 100 }}
                    sx={{ maxWidth: 300 }}
                />
                <div style={{ paddingLeft: '16px' }}>
                    <Button onClick={handleCreate} size="small" disabled={!newName.trim()}>
                        Add
                    </Button>
                </div>
            </div>
        </>
    );
};
